export default __webpack_public_path__ + "static/media/15.4fd2c349.png";